import { useState } from "react";
import {
  Form,
  Input,
  Button,
  Upload,
  Modal,
  message,
  Space,
  Breadcrumb,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useHttp } from "../../../utils/DataHendler";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const EventFormPage = () => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const { uploadFile, postData } = useHttp();
  const navigate = useNavigate();
  const { umkm_id } = useParams();
  const [loadingSubmit, setloadingSubmit] = useState(false);

  const [price, setPrice] = useState("");

  const handleChanges = (e) => {
    const numericValue = e.target.value.replace(/\D/g, "");
    form.setFieldsValue({ price: numericValue });
    setPrice(numericValue);
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(
      file.name || file.url?.substring(file.url.lastIndexOf("/") + 1)
    );
  };

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    if (newFileList.length > 0) {
      setSelectedFile(newFileList[0].originFileObj);
    } else {
      setSelectedFile(null);
    }
  };

  const beforeUpload = (file) => {
    const isJpg = file.type === "image/jpeg" || file.type === "image/jpg";
    if (!isJpg) {
      message.error("Hanya file JPG/JPEG yang diperbolehkan!");
      return Upload.LIST_IGNORE;
    }

    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error("Ukuran gambar tidak boleh lebih dari 5MB!");
      return Upload.LIST_IGNORE;
    }

    return true;
  };

  const handleCancel = () => setPreviewVisible(false);

  const onFinish = async (values) => {
    setloadingSubmit(true);
    if (!selectedFile) {
      message.error("Silakan upload gambar produk terlebih dahulu.");
      return;
    }

    try {
      const result = await uploadFile("/upload/file", selectedFile);
      const imageUrl = result.data.preview_url || result?.data?.url;

      if (!imageUrl) {
        throw new Error("Upload tidak mengembalikan URL gambar.");
      }

      await postData(
        `/event`,
        {
          title: values.title,
          description: values.description,
          top_image: imageUrl,
        },
        {},
        true
      );

      // console.log({
      //   name: values.name,
      //   price: values.price,
      //   description: values.description,
      //   image_url: imageUrl,
      //   umkm_id,
      // });

      message.success("Event berhasil ditambahkan.");
      form.resetFields();
      setFileList([]);
      setSelectedFile(null);
      setPrice("");
      navigate("/user/event-admin");
      setloadingSubmit(false);
    } catch (err) {
      setloadingSubmit(false);
      console.error("Upload failed", err);
      message.error("Gagal menyimpan produk.");
    }
  };

  return (
    <>
      <Breadcrumb style={{ margin: 0 }}>
        <Breadcrumb.Item>
          <a
            onClick={() => {
              navigate(`/user/event-admin`);
            }}
          >
            Event
          </a>
        </Breadcrumb.Item>
        <Breadcrumb.Item style={{ fontWeight: "bold" }}>
          Add Event
        </Breadcrumb.Item>
      </Breadcrumb>
      <br />
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ maxWidth: 600, margin: "0 auto" }}
      >
        <Form.Item
          name="title"
          label="Nama Event"
          rules={[{ required: true, message: "Nama event wajib diisi" }]}
        >
          <Input placeholder="Masukkan nama event" />
        </Form.Item>

        <Form.Item
          name="description"
          label="Deskripsi"
          rules={[{ required: true, message: "Deskripsi wajib diisi" }]}
        >
          <Input.TextArea rows={4} placeholder="Masukkan deskripsi event" />
        </Form.Item>

        <Form.Item label="Upload Gambar Evenet" required>
          <Upload
            listType="picture-card"
            fileList={fileList}
            onPreview={handlePreview}
            onChange={handleChange}
            beforeUpload={beforeUpload}
            maxCount={1}
          >
            {fileList.length >= 1 ? null : (
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            )}
          </Upload>

          <Modal
            open={previewVisible}
            title={previewTitle}
            footer={null}
            onCancel={handleCancel}
          >
            <img alt="preview" style={{ width: "100%" }} src={previewImage} />
          </Modal>
        </Form.Item>

        <Form.Item>
          <Space>
            <Button loading={loadingSubmit} type="primary" htmlType="submit">
              Publish Event
            </Button>
            <Button
              onClick={() => {
                form.resetFields();
                setFileList([]);
                setSelectedFile(null);
                setPrice("");
              }}
            >
              Reset
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </>
  );
};
